export default __webpack_public_path__ + "static/media/cpu.05a5851b.svg";